/**
 * 브라우저에서 `Blob` 응답을 파일로 저장한다(#704 CSV 다운로드 공용 유틸).
 *
 * `VenueImageListEditor`가 이미 쓰는 `URL.createObjectURL` 패턴을 방향만 반대로 재사용한다
 * (그쪽은 미리보기 표시, 이쪽은 다운로드 트리거) — 새 브라우저 API를 들여오지 않는다.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}
